import { LazyAction, LazyModule } from 'owa-bundling';
import { hasQueryStringParameter } from 'owa-querystring';
import { isFeatureEnabled } from 'owa-feature-flags';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "OfflineCalendarServices" */ './lazyIndex'),
    true
);

export const lazyTryGetCalendarViewOffline = new LazyAction(
    lazyModule,
    m => m.tryGetCalendarViewOffline
);

export const lazyOnGetCalendarViewResponse = new LazyAction(
    lazyModule,
    m => m.onGetCalendarViewResponse
);

export const lazyTryGetCalendarFoldersOffline = new LazyAction(
    lazyModule,
    m => m.tryGetCalendarFoldersOffline
);

export const lazyOnGetCalendarFoldersResponse = new LazyAction(
    lazyModule,
    m => m.onGetCalendarFoldersResponse
);

export function isOfflineEnabled() {
    return (
        isFeatureEnabled('fwk-offline-services') &&
        hasQueryStringParameter('offlineboot', window.location)
    );
}
